import { render } from "./AposModalBody.vue?vue&type=template&id=624e42b4&scoped=true"
import script from "./AposModalBody.vue?vue&type=script&lang=js"
export * from "./AposModalBody.vue?vue&type=script&lang=js"

import "./AposModalBody.vue?vue&type=style&index=0&id=624e42b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624e42b4"],['__file',"modal/ui/apos/components/AposModalBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "624e42b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('624e42b4', __exports__)) {
    api.reload('624e42b4', __exports__)
  }
  
  module.hot.accept("./AposModalBody.vue?vue&type=template&id=624e42b4&scoped=true", () => {
    api.rerender('624e42b4', render)
  })

}


export default __exports__